module.exports = __webpack_public_path__ + "static/020-a00542ca0065c0fc179c8c09e906a99e.jpg";